import { SignUpHeader } from '../../components/SignUpHeader';
import { ProSignUpForm } from '../../components/ProSignUpForm';
import { AuthTabs } from '../../components/AuthTabs';
import { RedirectIfAuthed } from '../../../lib/use-auth';

export default function ProSignUpPage() {
  return (
    <RedirectIfAuthed>
      <div className="size-full bg-white flex flex-col min-h-screen">
        <div className="pt-0">
          <SignUpHeader mode="signin" isProfessional={true} showSwitchButton={false} />
        </div>
        <div className="flex-1 flex flex-col items-center justify-center py-6 md:py-12 px-4">
          <AuthTabs mode="signup" active="professional" />
          <ProSignUpForm />
        </div>
      </div>
    </RedirectIfAuthed>
  );
}
